export enum PanelMemberStatus {
  InitialSignUp = 1,
  Flagged = 2,
  SignupComplete = 3,
  ProfileComplete = 4,
  Registered = 5,
  Blacklisted = 6,
  FailedRegistration = 7
}
